<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>
  <ng-container actions>
    <unity-action-shared [action]="createTemplateAction" />
  </ng-container>
  <unity-grid-form-template-shared />
</unity-page-container>
